export class TireReport {
    id?: string
    equipmentId = ''
    job = ''
    jobNumber = ''
    operatorName = 0
    dateTimeOfIssue: Date | null = new Date()
    county = ''
    equipmentClass = ''
    problemType = 'Flat'
    axleNumber: number | null = null
    side = 'Left'
    resolvedTireSize = ''
    submitterPhone = ''
    locationDescription = ''
    locationLatitude: number | null = null
    locationLongitude: number | null = null
    locationCapturedOn: Date | null = null
    shortDescription = ''
    notes = ''
    images: any[] = []
    existingImageUrls: string[] = []
    receiptImageUrls: string[] = []
    receiptImages: any[] = []
}

export const UTAH_COUNTIES = [
    'Beaver', 'Box Elder', 'Cache', 'Carbon', 'Daggett', 'Davis', 'Duchesne', 'Emery', 'Garfield', 'Grand',
    'Iron', 'Juab', 'Kane', 'Millard', 'Morgan', 'Piute', 'Rich', 'Salt Lake', 'San Juan', 'Sanpete',
    'Sevier', 'Summit', 'Tooele', 'Uintah', 'Utah', 'Wasatch', 'Washington', 'Wayne', 'Weber',
]

export const TIRE_PROBLEM_TYPES = [
    { value: 'Flat', label: 'Flat tire' },
    { value: 'Punctured', label: 'Punctured tire' },
    { value: 'WornOut', label: 'Worn out tire' },
]

export const TIRE_EQUIPMENT_CLASSES = [
    { value: 'PickupTruck', label: 'Pick-up truck' },
    { value: 'TrailerTruck', label: 'Trailer / TK' },
    { value: 'Equipment', label: 'Heavy equipment' },
]

export const TIRE_SIDES = [
    { value: 'Left', label: 'Left (as facing forward)' },
    { value: 'Right', label: 'Right (as facing forward)' },
]
